/**
 * Automations footer feature flag - org-aware.
 * Dashboard provides; BaseWidget and DashboardSection inject.
 */

import { computed, provide, inject, ref } from 'vue'
import { isAutomationsFooterEnabled } from '../utils/featureFlags.js'

const AUTOMATIONS_FOOTER_KEY = Symbol('automationsFooterEnabled')

/**
 * Provide automations footer enabled state (org-aware).
 * Call in Dashboard with orgId ref.
 * @param {import('vue').Ref<string|null>} orgIdRef
 * @returns {import('vue').ComputedRef<boolean>}
 */
export function provideAutomationsFooter(orgIdRef) {
  const enabled = computed(() => isAutomationsFooterEnabled(orgIdRef?.value ?? null))
  provide(AUTOMATIONS_FOOTER_KEY, enabled)
  return enabled
}

/**
 * Inject automations footer enabled state.
 * @returns {import('vue').Ref<boolean>|import('vue').ComputedRef<boolean>}
 */
export function useAutomationsFooter() {
  const enabled = inject(AUTOMATIONS_FOOTER_KEY, ref(false))
  return enabled
}
